import MuiFirstPage from '@mui/icons-material/FirstPage';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type FirstPageProps = SvgIconProps;

export const FirstPage = (props: FirstPageProps) => {
  return <MuiFirstPage {...props} />;
};
